export default __webpack_public_path__ + "static/meaningImg-b42d7979d43419bf21c1cead7b0f0b75.png";